// extracted by mini-css-extract-plugin
export default {"option":"OptionSelect_option__1W7UL","desabilitar":"OptionSelect_desabilitar__mKcl6","focado":"OptionSelect_focado__HsUnZ","novo":"OptionSelect_novo__2vpeO"};